export default __webpack_public_path__ + "static/media/beach.b5d68285.jpeg";